/* tslint:disable */

declare var Object: any;
export interface SFUploadPayHistoryInterface {
  "id"?: number;
}

export class SFUploadPayHistory implements SFUploadPayHistoryInterface {
  "id": number;
  constructor(data?: SFUploadPayHistoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFUploadPayHistory`.
   */
  public static getModelName() {
    return "SFUploadPayHistory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFUploadPayHistory for dynamic purposes.
  **/
  public static factory(data: SFUploadPayHistoryInterface): SFUploadPayHistory{
    return new SFUploadPayHistory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFUploadPayHistory',
      plural: 'SFUploadPayHistories',
      path: 'SFUploadPayHistories',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFUploadPayHistory.ts